import { deleteCookie, getCookie } from '@/utils/cookies';
import router from '@/router';
import { checkTokenExpired } from '@/utils/token';
import { renewalToken } from './auth-service';

// const axios = require("axios");
export const getURL = postfix => {
    let _postfix = postfix;
    if (window['appPostfix']) {
        _postfix = window['appPostfix'] + '/' + postfix;
    }
    let url;
    if (window.location.hostname === 'localhost') {
        if (process.env.VUE_APP_HOST !== undefined) {
            url = `http://${process.env.VUE_APP_HOST}:3100/${_postfix}`;
        } else {
            url = `http://${window.location.hostname}:3100/${_postfix}`;
        }
    } else {
        url = `${window.location.origin}/${_postfix}`;
    }
    return url;
};

export async function post(postfix, api, args, timeout) {
    const url = getURL(postfix);

    if (!timeout) {
        timeout = 90000;
    }
    try {
        const resp = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                api: api,
                args,
            }),
            signal: AbortSignal.timeout(timeout),
        });
        const result = await resp.json();

        return result;
    } catch (e) {
        return { result: false, err: e };
    }
}

export async function getDownload({ storage, fileName }, timeout) {
    let fileUrl = getURL('download');
    fileUrl = `${fileUrl}?uuid=${storage}`;

    if (!timeout) {
        timeout = 90000;
    }
    try {
        const response = await fetch(fileUrl, {
            method: 'GET',
            headers: {
                accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7',
            },
            signal: AbortSignal.timeout(timeout),
        });
        if (!response.ok) {
            throw new Error('Ошибка при загрузке файла');
        }
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); // Имя файла
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        return { result: true };
    } catch (e) {
        return { result: false, err: e };
    }
}

export async function auth(api, args, timeout) {
    let token = getCookie('token');
    if (!token) {
        router.push({
            name: 'loginForm',
        });
        return { result: false };
    }
    const { result, status } = checkTokenExpired(token);
    if (!result) {
        router.push({
            name: 'loginForm',
        });
        deleteCookie('token');
        deleteCookie('renewal');
        return { result: false };
    }
    if (status === 'Renewal Required') {
        const renewal = getCookie('renewal');
        const resp = await renewalToken(renewal);
        if (!resp.result) {
            router.push({
                name: 'loginForm',
            });
            deleteCookie('token');
            deleteCookie('renewal');
            return { result: false };
        }
    }
    token = getCookie('token');
    const appId = +getCookie('app');
    const depId = +getCookie('dep');
    if (args) {
        args.token = token;
        args.cookiesAppId = appId;
        args.cookiesDepId = depId;
        args.appId = appId;
        args.depId = depId;
        const result = await post('auth-api', api, args, timeout);
        return result;
    } else {
        const args = {};
        args.token = token;
        args.cookiesAppId = appId;
        args.cookiesDepId = depId;
        args.appId = appId;
        args.depId = depId;
        const result = await post('auth-api', api, args, timeout);
        return result;
    }
}

export async function api(api, args, timeout) {
    let token = getCookie('token');
    if (!token) {
        router.push({
            name: 'loginForm',
        });
        return { result: false };
    }
    const { result, status } = checkTokenExpired(token);
    if (!result) {
        router.push({
            name: 'loginForm',
        });
        deleteCookie('token');
        deleteCookie('renewal');
        return { result: false };
    }
    if (status === 'Renewal Required') {
        const renewal = getCookie('renewal');
        const resp = await renewalToken(renewal);
        if (!resp.result) {
            router.push({
                name: 'loginForm',
            });
            deleteCookie('token');
            deleteCookie('renewal');
            return { result: false };
        }
    }
    token = getCookie('token');
    const appId = +getCookie('app');
    const depId = +getCookie('dep');
    if (args) {
        args.token = token;
        args.cookiesAppId = appId;
        args.cookiesDepId = depId;
        args.appId = appId;
        args.depId = depId;
        const result = await post('api', api, args, timeout);
        return result;
    } else {
        const args = {};
        args.token = token;
        args.cookiesAppId = appId;
        args.cookiesDepId = depId;

        args.appId = appId;
        args.depId = depId;
        const result = await post('api', api, args, timeout);
        return result;
    }
}

export function common(api, args, timeout) {
    return post('common', api, args, timeout);
}
